import { Skeleton } from '@eika/skeleton';
import './header-ingress-skeleton.scss';

interface HeaderIngressSkeletonProps {
    header: string;
}

export const HeaderIngressSkeleton = ({ header }: HeaderIngressSkeletonProps) => (
    <div className="header-ingress-skeleton">
        <h1>{header}</h1>
        <div className="header-ingress-skeleton__ingress">
            <Skeleton />
            <Skeleton />
            <Skeleton width="50%" />
        </div>
    </div>
);
